module.exports = __webpack_public_path__ + "static/media/expand-arrow.c9c7a94f.svg";